import { render, staticRenderFns } from "./Pos_edit_product_service.vue?vue&type=template&id=6772ef98&scoped=true&"
import script from "./Pos_edit_product_service.vue?vue&type=script&lang=js&"
export * from "./Pos_edit_product_service.vue?vue&type=script&lang=js&"
import style0 from "./Pos_edit_product_service.vue?vue&type=style&index=0&id=6772ef98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6772ef98",
  null
  
)

export default component.exports